import Swiper, { Zoom } from 'swiper';

export default () => {
	return {
		isLightboxOpen: false,
		lightboxImages: [],
		swiperObj: new Swiper('.lightbox-swiper', {
			modules: [Zoom],
			zoom: true,
		}),

		cache: {
			zoomScale: 1,
			slideCount: 6,
			slideIndex: 1,
		},

		refreshZoom() {
			this.cache.zoomScale = this.swiperObj.zoom.scale;
		},

		refreshSlideIndex() {
			this.cache.slideCount = this.swiperObj.slides.length;
			this.cache.slideIndex = this.swiperObj.activeIndex;
		},

		updateLightboxLinks() {
			const lightboxOpener =
				(lightboxid = 'lightbox-0') =>
				(startingIndex = 0) =>
				(event) => {
					this.open(lightboxid, startingIndex);
					event.preventDefault();
				};
			document.querySelectorAll('[data-lightbox-id]').forEach((cont) =>
				cont
					.querySelectorAll(
						'a.lightbox-link, .lightbox-opener-element'
					)
					.forEach((link, index) => {
						link.onclick = cont.dataset.lightboxId
							? lightboxOpener(cont.dataset.lightboxId)(index)
							: lightboxOpener()(index);
					})
			);
		},

		init() {
			this.swiperObj.on('zoomChange', () =>
				this.$nextTick(() => this.refreshZoom())
			);

			this.updateLightboxLinks();
		},

		hasCurrentImageZoom() {
			return (
				!this.lightboxImages[this.swiperObj.activeIndex]?.noZoom ||
				false
			);
		},

		isOnlyOnePicture() {
			return this.lightboxImages.length === 1;
		},

		open(lightboxid = 'lightbox-0', startingIndex = 0) {
			const lightboxImages = [];
			document.querySelectorAll('[data-lightbox-id]').forEach((cont) => {
				if (cont.dataset.lightboxId === lightboxid) {
					cont.querySelectorAll(
						'a.lightbox-link, .lightbox-element, .lightbox-opener-element'
					).forEach((element) => {
						let item;
						if (
							element.classList.contains('lightbox-element') ||
							element.classList.contains(
								'lightbox-opener-element'
							)
						) {
							item = {
								id: lightboxImages.length,
								href: element.dataset.image,
								thumb: element.dataset.thumb,
								subtext: element.dataset.subtext,
								noZoom: element.dataset.noZoom || false,
								insideHref: element.dataset.insideHref || '',
								imageAlt: element.dataset.imageAlt || '',
								isEmbed: element.dataset.isEmbed || false,
							};
						} else {
							item = {
								id: lightboxImages.length,
								href: element.href,
								thumb: element.dataset.thumb,
								subtext: element.dataset.subtext,
								noZoom: element.dataset.noZoom || false,
								insideHref: element.dataset.insideHref || '',
								imageAlt: element.dataset.imageAlt || '',
								isEmbed: element.dataset.isEmbed || false,
							};
						}
						lightboxImages.push(item);
					});
				}
			});
			this.lightboxImages = lightboxImages;

			setTimeout(() => this.refreshSlideIndex(), 50);
			setTimeout(() => this.swiperObj.slideTo(startingIndex), 50);
			this.swiperObj.on('activeIndexChange', () =>
				this.refreshSlideIndex()
			);

			this.isLightboxOpen = true;
		},
	};
};
